// @owners { team: patients }

// MMKV Storage key the internal-testing bypass token is persisted under — see isBypassed.ts and
// useScheduledDowntime.ts.
export const SCHEDULED_DOWNTIME_BYPASS_TOKEN_STORAGE_KEY = 'scheduled-downtime-bypass-token';

// Path segment used to recognize a bypass link on both platforms (apps/web/src/index.tsx and
// apps/native/src/lib/BranchListener.tsx). Keep in sync with
// bin/scheduled-downtime/upload-scheduled-downtime.sh, which prints links using this same path.
export const SCHEDULED_DOWNTIME_BYPASS_PATH = '/scheduled-downtime-bypass';
